<template>
  <div
    v-if="quoteRef && quoteRef.length"
    class="mt-2 mt-md-0 flex-shrink-0 d-flex align-center"
  >
    <span class="mr-1">
      Quote Ref: <strong>{{ quoteRef }}</strong>
    </span>
    <qz-tooltip
      bottom
    >
      <template #tooltip-body>
        This quote reference is unique. Please provide this for any inquiries regarding your quote.
      </template>
    </qz-tooltip>
  </div>
</template>
<script>
import QzTooltip from '@/components/QzTooltip/QzTooltip';

export default {
  name: 'results-info-quote-ref',
  components: {
    QzTooltip,
  },
  props: {
    quoteRef: {
      type: String,
      default: null,
    },
  },
};
</script>
